import React from 'react'
import PropTypes from 'prop-types'
import STYLE_CONSTANTS from '~/style/constants'

const MountainIcon = ({ color, outline, width, height }) => {
  return (
    <svg 
      width={width || "22px"} 
      height={height || "22px"} 
      viewBox="0 0 22 22" 
      version="1.1"
    >
      <defs>
        <circle id="path-1" cx="11" cy="11" r="11" />
      </defs>
      <g
        id="desktop"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="New-flow_02_multiple-tickets-(1)"
          transform="translate(-646.000000, -304.000000)"
        >
          <g id="Group-6-Copy" transform="translate(634.000000, 290.000000)">
            <g id="Group-3" transform="translate(12.000000, 14.000000)">
              <g id="Shape">
                {outline ? (
                  <mask id="mask-2" fill="#FFFFFF">
                    <use xlinkHref="#path-1" />
                  </mask>
                ) : null}
                <use
                  id="Mask"
                  fill={color}
                  fillRule="nonzero"
                  xlinkHref="#path-1"
                />
                <path
                  d="M17.1887276,21 L10.5943638,13.6343284 L4,21 C4,21 7.07227289,23.8572457 10.5943638,23.8572457 C14.1164547,23.8572457 17.1887276,21 17.1887276,21 Z M26,17.0820896 L26,20.2164179 C26,20.6865672 25.6618275,21 25.1545687,21 L18.7292912,21 L14.6712212,16.4552239 L20.0819812,10.5 L26,17.0820896 Z M8,11 C6.8954305,11 6,10.1045695 6,9 C6,7.8954305 6.8954305,7 8,7 C9.1045695,7 10,7.8954305 10,9 C10,10.1045695 9.1045695,11 8,11 Z"
                  fill="#FFFFFF"
                  fillRule="nonzero"
                  mask="url(#mask-2)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

MountainIcon.defaultProps = {
  color: STYLE_CONSTANTS.colors.text.buttonGray
}

MountainIcon.propTypes = {
  color: PropTypes.string
}

export default MountainIcon
